import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { client } from '../api/client'
const initialState = {loginState:-1,user:{name:''}}
export const flaglogin = createAsyncThunk('user/flaglogin', async ({username,password}) => (await client.post('/flaglogin',{username,password})).data)
export const login = flaglogin
export const restoreSession = createAsyncThunk('user/restore', async () => (await client.get('/api/session')).data)
export const bet = createAsyncThunk('user/bet', async ({betData}) => (await client.post('/bet',{betData})).data)
const slice = createSlice({
  name:'user',initialState,reducers:{clearUser:()=>initialState},
  extraReducers(builder) {
    const accept = (state,{payload}) => ({loginState:payload.status,user:payload.user})
    builder.addCase(flaglogin.fulfilled,accept).addCase(restoreSession.fulfilled,accept)
      .addCase(restoreSession.rejected,()=>initialState)
      .addCase(bet.fulfilled,(state,{payload})=>{state.user.amount=payload.amount})
  }
})
export const {clearUser} = slice.actions
export default slice.reducer
